import Vue from 'vue'
import Router from 'vue-router'
import Signup from '@/components/Signup'

Vue.use(Router)

export default new Router({
  // mode: "query",
  routes: [
    {
      path: '/',
      name: 'Signup',
      component: Signup
    },
    {
      path: '/fadan',
      name: '发单',
      component: () => import("../views/fadan/index.vue"),
    },
    {
      path: '/shixiao',
      name: 'shixiao',
      component: () => import("../views/shixiao/index.vue"),
    },
  ],
  // mode: 'history',
  // base: '/signup/'
})



// WEBPACK FOOTER //
// ./src/router/index.js